import {ArenaTitleDefaultBox} from './arena-title.default.box';


export const ArenaTitleBox = ArenaTitleDefaultBox;